import { ButtonVariant, TestableComponentProps } from '@dreryk/react-components';

import { StyledTileItemPrimaryButton } from './TileItemPrimaryButton.styled';

type TileItemPrimaryButtonProps = { onClick: VoidFunction; label: string } & TestableComponentProps;

export const TileItemPrimaryButton = (props: TileItemPrimaryButtonProps): JSX.Element => {
   return (
      <StyledTileItemPrimaryButton
         variant={ButtonVariant.PRIMARY}
         label={props.label}
         testId={props.testId}
         onClick={props.onClick}
         fullLength
      />
   );
};
